import React from "react";
import { formatInTimeZone } from "date-fns-tz";
import { Icons, Text } from "@pushpress/shared-components";
import { joinStrings } from "../../../utils/misc";
import UserAvatar from "../../../components/common/UserAvatar/UserAvatar";
import AppointmentStatusChip from "../AppointmentStatusChip/AppointmentStatusChip";
import { AppointmentFragment } from "./AppointmentsStart-generated.hooks";
import { getAppointmentStatusName } from "../AppointmentsUtils";
import styles from "./ListEvent.module.scss";

interface ListEventProps {
  appointment: AppointmentFragment;
  timezone: string;
}

function ListEvent(props: ListEventProps) {
  const { appointment, timezone } = props;
  const { startTime, endTime, user, staff, appointmentType } = appointment;

  const start = new Date(startTime);
  const end = new Date(endTime);
  const time = `${formatInTimeZone(
    start,
    timezone,
    "h:mma",
  )} — ${formatInTimeZone(end, timezone, "h:mma")}`.toLocaleLowerCase();
  const userName = joinStrings(user.firstName, user.lastName);
  const staffName = staff
    ? joinStrings(staff.firstName, staff.lastName)
    : undefined;
  const statusName = getAppointmentStatusName(appointment);
  const isUnpaid =
    statusName === "UNPAID LATE CANCEL" || statusName === "UNPAID NO SHOW";

  return (
    <div className={styles.root}>
      <div className={styles.time}>
        {isUnpaid && <Icons.Alert className={styles.alertIcon} />}
        <Text variant="body-lg" color="wolf-800">
          {time}
        </Text>
      </div>
      <div className={styles.user}>
        <UserAvatar data={user} size="small" />
        <Text variant="body-lg" color="wolf-800">
          {userName} &nbsp;&nbsp; {" ∙ "} &nbsp;&nbsp; {appointmentType?.name}
        </Text>
      </div>
      <div className={styles.staff}>
        {staff && (
          <>
            <UserAvatar data={staff} size="small" />
            <Text variant="body-lg" color="wolf-800">
              {staffName}
            </Text>
          </>
        )}
      </div>
      <div className={styles.status}>
        <AppointmentStatusChip data={appointment} />
      </div>
    </div>
  );
}

export default ListEvent;
